module.exports = __webpack_public_path__ + "img/Pack-cardio.3a13c23b.png";